import { Component } from '@angular/core';
import { ApiUrlHelper } from '../../../../common/api-url-helper';
import { CommonService } from '../../../../services/common/common.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { StateService } from '../../../../services/common/claim-year.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DataLicenceProject, commonLabelConstants } from '../../../../constants/label-constants';
import { environment } from '../../../../../environments/environment';
import { CustomCurrencyPipe } from '../../../../common/pipes/custom-currency.pipe';
import { SharedService } from '../../../../services/shared-service/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../../services/common/validation-service';

@Component({
  selector: 'app-data-licence-form',
  templateUrl: './data-licence-form.component.html',
  styleUrl: './data-licence-form.component.scss'
})

export class DataLicenceFormComponent {

  env : any = environment;
  projectList: any = [];
  companyId: any = 0
  claimYearId: any = 0;
  dataLicenceRNDForm!: FormGroup;
  detail: any = []
  isLoading: boolean = false;
  labelConstants = DataLicenceProject;
  onDestroy$: Subject<void> = new Subject();
  commonLabelConstants = commonLabelConstants;
  isLocked: boolean = false;

  constructor(private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly sharedService: SharedService,
    private readonly currencyPipe : CustomCurrencyPipe,
  private readonly validationService:ValidationService) { }

  get dataLicence(): FormArray {
    return this.dataLicenceRNDForm.get('dataLicence') as FormArray
  }

  ngOnInit() {
    this.dataLicenceRNDForm = this.fb.group({
      dataLicence: this.fb.array([])
    });
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId ?? null;

      if (this.companyId && this.claimYearId) {
        this.resetForm();
        this.getProjectListCompanyWise(this.companyId, this.claimYearId)
      }
    });
  }

  resetForm(){
    this.dataLicenceRNDForm = this.fb.group({
      dataLicence: this.fb.array([])
    });
  }

  createDataLicence(): FormGroup {
    return this.fb.group({
      dataLicenceId: [null],
      dataLicenceName: [{ value: '', disabled: true }],
      dataLicenceResourceId: [0],
      projects: this.fb.array([]),
      totalGross: [{ value: '', disabled: true }],
      totalEligibilityPer: [{ value: 0, disabled: true }],
    });
  }

  getProjectListCompanyWise(companyId: any, claimYearId: any) {
    let api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace('{companyId}', companyId).replace('{claimYearId}', claimYearId);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.projectList = response.data;
          this.getDataLicenceDetail()
        }
        else {
          this.projectList = [];
        }
      },
      error: (error: any) => {
        console.log(error);
      },
      complete: () => {
      },
    });
  }

  getDataLicenceDetail() {
    this.isLoading = true;
    let obj = {
      companyId: this.companyId,
      claimYearId: this.claimYearId
    }
    let api = this.api.apiUrl.DataLicenceResource.dataLicenceList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          this.detail = response.data;
          this.isLocked = ( this.detail[0]?.isLocked ?? false);
          this.detail.forEach((item: any) => {
            const newDataLicence = this.createDataLicence();
            newDataLicence.patchValue({
              dataLicenceId: item.dataLicenceId,
              dataLicenceName: item.licenceName,
              dataLicenceResourceId: item.dataLicenceResourceId,
              totalGross: item.cost,
              totalEligibilityPer: item.totalEligibilityAmount,
            });
            const dataLicenceDetailsArray = newDataLicence.get('projects') as FormArray;
            this.projectList.forEach((itemDetail: any) => {
              const newProjectDetail = this.createDataLicenceProjectDetail();

              const projectData = item.projects.find(
                (projectDetail: any) =>
                  projectDetail.projectId == itemDetail.projectId
              );

              const rndEligibilityValue =
                 projectData?.rndEligibility
                  ? projectData.rndEligibility
                  : '0';
                  newProjectDetail.patchValue({
                    dataLicenceEligibilityId: projectData
                  ? projectData.staffCostResourceEligibilityId
                  : 0,
                  dataLicenceResourceId: projectData
                  ? projectData.staffCostResourceId
                  : 0,
                  projectId: itemDetail.projectId,
                  rndEligibility: rndEligibilityValue,
              });
              newProjectDetail.disable();
              dataLicenceDetailsArray.push(newProjectDetail);
            });
            this.dataLicence.push(newDataLicence);
          })
        }

      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  createDataLicenceProjectDetail() {
    return this.fb.group({
      dataLicenceEligibilityId: [null],
      dataLicenceResourceId: [null],
      projectId: [''],
      rndEligibility: ['']
    });
  }

  getItemAtIndex(index: number): FormGroup {
    return this.dataLicence.at(index) as FormGroup;
  }

  getProjectDetails(index: any) {
    return this.getItemAtIndex(index).get('projects') as FormArray;

  }

  getCostTotal(): number {
    return this.dataLicence.controls.reduce((totalCost, contractor) => {
      const cost = contractor.get('totalGross')?.value || 0;
      return totalCost + Number(cost);
    }, 0);
  }

  getTotalProduct(projectIndex: number): string | null {
    let totalProduct = 0;
    for (let i = 0; i < this.dataLicence.length; i++) {
        const employee = this.getItemAtIndex(i);
        const projectDetails = this.getProjectDetails(i);

        if (projectIndex < projectDetails.length) {
            const totalGrossStr = employee.get('totalGross')?.value;
            const totalGross = parseFloat(totalGrossStr) || 0;

            const rndEligibilityValueStr = projectDetails.at(projectIndex).get('rndEligibility')?.value;
            const rndEligibility = (parseFloat(rndEligibilityValueStr) || 0) / 100;

            totalProduct += totalGross * rndEligibility;
        } else {
            console.warn(`Project index ${projectIndex} is out of bounds for employee ${i}.`);
        }
    }

    return this.currencyPipe.transform(totalProduct === 0 ? 0 : Number(totalProduct.toFixed(2)) , environment.CurrencyFormat);
  }

  getTotalQualifyingCosts(): number {
    let total = 0;
    const employeeArray = this.dataLicenceRNDForm.get('dataLicence') as FormArray;

    employeeArray.controls.forEach((employee) => {
      total += employee.get('totalEligibilityPer')?.value || 0;
    });

    return total;
  }


  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  exportList(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
    };
    let api = this.api.apiUrl.DataLicenceResource.ExportdataLicenceCostCategory;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Data Licences - Qualifying Expenditure by Cost Category.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
